import { Fonts } from '@portal/entity-services/organisations/src/lib/enums/fonts.enum';

export interface HelpPageParameter {
  country?: string;
  emailOrUrl?: string;
  notes?: string;
}

export interface HelpPageParameterResponse {
  [key: string]: {
    emailOrUrl?: string;
    notes?: string;
  };
}

export interface TextParameter {
  brandText?: string;
  privacyPolicyUrl?: string;
  loginDomainName?: string;
}

export interface NavBarParameter {
  navbarBackgroundColor?: string;
  navbarItemColor?: string;
  navbarBoxShadowColor?: string;
  navbarItemHoverColor?: string;
  navbarItemHoverBackgroundColor?: string;
  navbarItemActiveColor?: string;
  navbarItemActiveBackgroundColor?: string;
  navbarBurgerColor?: string;
  navbarDropdownItemColor?: string;
  navbarDropdownBackgroundColor?: string;
  navbarDropdownArrow?: string;
  navbarDropdownBoxedShadow?: string;
  navbarDropdownItemHoverColor?: string;
  navbarDropdownItemHoverBackgroundColor?: string;
  navbarDropdownItemActiveColor?: string;
  navbarDropdownItemActiveBackgroundColor?: string;
  navbarDividerBackgroundColor?: string;
}

export interface BrandParameter {
  brandBackground?: string;
  brandText?: string;
  brandOutlinedText?: string;
}

export interface DangerButtonParameter {
  dangerButtonBackgroundColor?: string;
  dangerButtonTextColor?: string;
  dangerButtonBorderColor?: string;
  dangerButtonHoverBackgroundColor?: string;
  dangerButtonHoverTextColor?: string;
  dangerButtonHoverBorderColor?: string;
  dangerButtonFocusBackgroundColor?: string;
  dangerButtonFocusTextColor?: string;
  dangerButtonFocusBorderColor?: string;
  dangerButtonActiveBackgroundColor?: string;
  dangerButtonActiveTextColor?: string;
  dangerButtonActiveBorderColor?: string;
  dangerButtonOutlinedTextColor?: string;
  dangerButtonOutlinedBorderColor?: string;
  dangerButtonOutlinedHoverBackgroundColor?: string;
  dangerButtonOutlinedHoverTextColor?: string;
  dangerButtonOutlinedHoverBorderColor?: string;
  dangerButtonOutlinedFocusBackgroundColor?: string;
  dangerButtonOutlinedFocusTextColor?: string;
  dangerButtonOutlinedFocusBorderColor?: string;
  dangerButtonOutlinedActiveBackgroundColor?: string;
  dangerButtonOutlinedActiveTextColor?: string;
  dangerButtonOutlinedActiveBorderColor?: string;
}

export interface TemplatePageStyle {
  font?: Fonts[];
  navBar?: NavBarParameter;
  brand?: BrandParameter;
  dangerButton?: DangerButtonParameter;
}

export interface TemplateParametersResponse {
  id?: string;
  text?: TextParameter;
  logo?: string;
  favicon?: string;
  pageStyle?: TemplatePageStyle;
  helpPage?: HelpPageParameterResponse[];
}

export interface TemplateParameters {
  id?: string;
  text?: TextParameter;
  helpPage?: HelpPageParameter[];
  logo?: File[];
  favicon?: File[];
  pageStyle?: TemplatePageStyle;
}
